// Runtime configuration, fetched rather than compiled in.
//
// config.json is written into the site bucket by the CDK deployment (see
// lib/portal-site.ts), so this bundle contains no pool ids, no client ids, and no
// hostnames. That means the frontend builds without AWS credentials and without
// knowing which environment it will be served from, and a rotated app client
// does not need a rebuild.

// Federated staff sign-in. Absent until the Entra application is live, which is
// what the login form keys the SSO button off: the deployment writes this block
// from the same values it created the Cognito provider with, so the button cannot
// offer a provider that does not exist.
export interface AdminSsoConfig {
  // Cognito hosted-UI domain, e.g. trx-sftp-prod.auth.us-east-2.amazoncognito.com.
  domain: string;
  // The provider as Cognito names it, passed as identity_provider to skip the
  // hosted UI's account picker.
  providerName: string;
  // Where Cognito sends the browser back. Also registered on the app client,
  // which refuses any redirect_uri that is not one of its callback URLs.
  callbackPath: string;
  scopes: string[];
}

export interface PortalConfig {
  region: string;
  apiBase: string;
  adminPoolId: string;
  adminClientId: string;
  partnerPoolId: string;
  partnerClientId: string;
  sftpEndpoint: string;
  adminSso?: AdminSsoConfig;
  // False until a sending domain is configured. Folders can still be marked to
  // notify, but nothing is sent, and the folder editor says so.
  uploadNotifications?: boolean;
}

let cached: PortalConfig | undefined;

export const loadConfig = async (): Promise<PortalConfig> => {
  if (cached) return cached;
  // no-store, because a cached config.json from a previous deploy would point at
  // resources that may no longer exist.
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Could not load portal configuration (HTTP ${response.status})`);
  }
  cached = (await response.json()) as PortalConfig;
  return cached;
};
